import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	deleteArtisticMovement,
	getArtisticMovements,
} from "../../../../api/artisticMovement";
import { postLog } from "../../../../api/log";
import { LOGS } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
	buttonsStyle,
	dateFormatter,
	getCurrentTablePage,
} from "../../../components/tables/table";

function getData(artisticMovements) {
	let data = [];
	for (let i = 0; i < artisticMovements.length; ++i) {
		const elem = {};
		const artisticMovement = artisticMovements[i];

		elem.name = artisticMovement?.name;
		elem.createdAt = artisticMovement?.createdAt;
		elem.id = artisticMovement?._id;

		data = data.concat(elem);
	}
	return data;
}

export default function ArtisticMovementsPage() {
	const [data, setData] = useState([]);
	const [selectedArtisticMovement, setSelectedArtisticMovement] = useState(
		null
	);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);

	const location = useLocation();

	const history = useHistory();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item._id === cell);
		return (
			<>
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							history.push({
								pathname:
									"/artistic-movements/" + cell + "/edit",
								state: {
									page: getCurrentTablePage(location),
								},
							});
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				<Tooltip title="Delete">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							setSelectedArtisticMovement(elem);
							setOpenConfirmDialog(true);
						}}
					>
						<DeleteIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "name", text: "Name", sort: true },
		{
			dataField: "createdAt",
			text: "Created At",
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getArtisticMovements()
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get artistic movements.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Artistic movement list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => {
								history.push({
									pathname: "/artistic-movements/edit",
									state: {
										page: getCurrentTablePage(location),
									},
								});
							}}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={getData(data)} columns={columns} />
					<ConfirmDialog
						title={
							"Are you sure you want to delete this artistic movement?"
						}
						open={openConfirmDialog}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteArtisticMovement(
								selectedArtisticMovement?._id
							)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										postLog(
											loggedUser,
											LOGS.FIELDS.ARTISTIC_MOVEMENTS,
											`${LOGS.ACTIONS.DELETE}-${selectedArtisticMovement?.name}`
										);
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"Artistic movement deleted successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not delete artistic movement.",
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
